import "./ServicesAndSEO.module.css";
import Header from "@/reusable_sections/Header";
import StrategicGrowthServices from "./sections/StrategicGrowthServices";
import SeoSuccessRoadmap from "./sections/SeoSuccessRoadmap";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import SiteReadyFooter from "@/reusable_sections/Footer";
export default function ServicesAndSEOPage() {
  return <div>
      <Header />
      <StrategicGrowthServices />
      <SeoSuccessRoadmap />
      <FrequentlyAskedQuestions />
      <SiteReadyFooter />
    </div>;
}